import React from 'react';
import { Stack, Box } from '@mui/material';
import { IEvent } from '../../types/global/helper';
import { Checkroom, LocalActivity, PersonOutline } from '@mui/icons-material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';

export interface IEventDescripiton {
    event: IEvent;
}

const EventHighlight: React.FC<IEventDescripiton> = ({ event }) => {
    return (
        <React.Fragment>
            <Stack width={'100%'} justifyContent="center" my={4}>
                <Stack direction="row" gap={2} width={'100%'} justifyContent="center" flexWrap="wrap">
                    {!!event.age_restriction && (
                        <Box
                            sx={{
                                backgroundColor: 'rgba(33, 150, 243, 0.2)',
                                border: '1px solid rgba(33, 150, 243, 0.5)',
                                borderRadius: 2,
                                px: 2,
                                py: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <TextWithIcon
                                icon={
                                    <PersonOutline
                                        sx={{
                                            color: '#2196F3',
                                            fontSize: '18px',
                                        }}
                                    />
                                }
                                text={`${event.age_restriction}+`}
                                typographyProps={{
                                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                    fontSize: 16,
                                    color: '#2196F3',
                                }}
                            />
                        </Box>
                    )}
                    {!!event.dress_code && (
                        <Box
                            sx={{
                                backgroundColor: 'rgba(156, 39, 176, 0.2)',
                                border: '1px solid rgba(156, 39, 176, 0.5)',
                                borderRadius: 2,
                                px: 2,
                                py: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <TextWithIcon
                                icon={
                                    <Checkroom
                                        sx={{
                                            color: '#9C27B0',
                                            fontSize: '18px',
                                        }}
                                    />
                                }
                                text={`${event.dress_code}`}
                                typographyProps={{
                                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                    fontSize: 16,
                                    color: '#9C27B0',
                                }}
                            />
                        </Box>
                    )}
                    {!!event.max_ticket_purchasable_per_person && (
                        <Box
                            sx={{
                                backgroundColor: 'rgba(255, 152, 0, 0.2)',
                                border: '1px solid rgba(255, 152, 0, 0.5)',
                                borderRadius: 2,
                                px: 2,
                                py: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <TextWithIcon
                                icon={
                                    <LocalActivity
                                        sx={{
                                            color: '#FF9800',
                                            fontSize: '18px',
                                        }}
                                    />
                                }
                                text={`${event.max_ticket_purchasable_per_person} tickets max per person`}
                                typographyProps={{
                                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                    fontSize: 16,
                                    color: '#FF9800',
                                }}
                            />
                        </Box>
                    )}
                </Stack>
            </Stack>
        </React.Fragment>
    );
};

export { EventHighlight };
